import React from 'react';
import { Col, FormControl, InputGroup, Media, Row } from 'react-bootstrap';
import FontAwesome from 'react-fontawesome';
import Select from 'react-select';

const getResourceFullName = (r) => `${r.firstName || ''} ${r.lastName || ''}`;

const filterOption = (option, filterString) =>
  getResourceFullName(option).toLocaleLowerCase().indexOf(filterString.toLocaleLowerCase()) >= 0;

const ResourceEdit = ({ crewResource, onChange, onDelete, resources,showpercentage }) => (
  <Media>
    <Media.Left>
      <FontAwesome name="user-circle-o" /><br />
      {onDelete ? <FontAwesome className="text-danger" name="times" onClick={onDelete} /> : null}
    </Media.Left>
    <Media.Body>
      <Media.Heading>Resource</Media.Heading>
      <Row>
        <Col md={showpercentage?6:12}>
          <Select
            clearable={false}
            filterOption={filterOption}
            onChange={(e) => onChange({ resource: e, resourcePercentage: crewResource ? crewResource.resourcePercentage : null })}
            optionRenderer={getResourceFullName}
            options={resources}
            value={crewResource ? crewResource.resource.id : ''}
            valueKey="id"
            valueRenderer={getResourceFullName}
          />
        </Col>
        { showpercentage && <Col md={6}>
          <InputGroup>
            <FormControl
              disabled={!crewResource}
              onChange={(e) => onChange({ resource: crewResource ? crewResource.resource : null, resourcePercentage: Number(e.target.value) })}
              value={crewResource ? crewResource.resourcePercentage || '' : ''}
            />
            <InputGroup.Addon>
              <FontAwesome name="percent" />
            </InputGroup.Addon>
          </InputGroup>
        </Col>}
      </Row>
    </Media.Body>
  </Media>
);

export default ResourceEdit;
